import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Container } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { withServerErrorCode } from "@plone/volto/helpers/Utils/Utils";
import { getBaseUrl } from "@plone/volto/helpers/Url/Url";
import BodyClass from "@plone/volto/helpers/BodyClass/BodyClass";

const Unauthorized = () => {
  const error_message = useSelector((state) => state.apierror?.message);
  let location = useLocation();

  return (
    <Container className="view-wrapper">
      <BodyClass className="view-unauthorized" />
      <h3>
        <FormattedMessage id="Please log in" defaultMessage="Please log in" />
      </h3>
      <p className="description">
        <FormattedMessage
          id="Welcome. This page is for CRA subscribers - please {login} to keep reading."
          defaultMessage="Welcome. This page is for CRA subscribers - please {login} to keep reading."
          values={{
            login: (
              <Link
                to={{
                  pathname: `${getBaseUrl(location.pathname)}/login`,
                  state: {
                    // This is needed to cover the use case of being logged in in
                    // another backend (eg. in development), having a token for
                    // localhost and try to use it, the login route has to know that
                    // it's the same as it comes from a logout
                    isLogout: true,
                  },
                }}
              >
                <FormattedMessage id="log in" defaultMessage="log in" />
              </Link>
            ),
          }}
        />
      </p>
      <p>
        <FormattedMessage
          id="Not yet a subscriber? We'd love to have you. {site_admin} to find out more about access options."
          defaultMessage="Not yet a subscriber? We'd love to have you. {site_admin} to find out more about access options."
          values={{
            site_admin: (
              <Link to="/contact">
                <FormattedMessage id="Contact Us" defaultMessage="Contact us" />
              </Link>
            ),
          }}
        />
      </p>
    </Container>
  );
};
const UnauthorizedWithCode = withServerErrorCode(401)(Unauthorized);
UnauthorizedWithCode.displayName = "unauthorized";
export default UnauthorizedWithCode;
